import React, { useState } from "react";
import { BiSolidRightArrow } from "react-icons/bi";
import { BiSolidDownArrow } from "react-icons/bi";
import axios from "axios";
import config from "../config";
const TradeDetails = ({basketId, keyName, basket, status, uniqueClientCount = 0 } ) => {
    const [accOpen, setAccopen] = useState(false)
    const [isMobileView, setIsMobileView] = useState(() => window.innerWidth < 768);

    const [errorBasket, setErrorBasket] = useState(basket);
    const [lists, setLists] = useState(null);

    const getUniqueClientCount = (rows = []) => {
        const clients = new Set(
            rows
                .map((row) => String(row?.clientCode || "").trim())
                .filter((clientCode) => clientCode !== "")
        );
        return clients.size;
    };

    const detailUniqueClientCount = Array.isArray(lists) ? getUniqueClientCount(lists) : null;
    const displayUniqueClientCount = detailUniqueClientCount !== null ? detailUniqueClientCount : uniqueClientCount;

    const handleOpen = async (basketId, status) => {

        //let basketId = e.currentTarget.getAttribute("id");
        if(basketId != null && !accOpen){
            try {
                const res = await axios.get(config.BL_API_URL+"/transaction/v1/getTradedTransactionDetails", {params: {basketId, status}});
                //console.log(res.data)
          
                if (res.data)
                  setLists(res.data)
                //else
                  //setErr("backend error")
          
              } catch (err) {

                //if (err.response.status !== "Success")
                    //setErr("Server error...");
              }

        }
        setAccopen(!accOpen)
    }

    React.useEffect(() => {
        const handleResize = () => setIsMobileView(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    
    return (
        <div className="py-1">
            <button id={basketId} onClick={e => handleOpen(basketId, status)} className="p-2 flex justify-between items-center w-full text-center bg-btnSecondary text-white rounded-lg">
                <span className="w-full text-center ">{keyName} total {status} {basket.errorCount} | total clients {displayUniqueClientCount}</span>
                {accOpen ? <BiSolidDownArrow className="text-yellow-300" /> : <BiSolidRightArrow className="text-yellow-200" />}
            </button>
            <div className={`mx-2 grid overflow-hidden transition-all duration-300 ease-in-out text-slate-600 text-sm ${ accOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                }`}>
                <div className="overflow-hidden">
                    <div className="flex flex-col">
                        <div className="-m-1.5 overflow-x-auto">
                            <div className="p-1.5 min-w-full inline-block align-middle">
                                {!isMobileView && <div className="border rounded-lg divide-y divide-gray-200 ">
                                    <table className="min-w-full divide-y divide-gray-400 w-full flex flex-col items-center justify-between"> {/* overflow-y-scroll"> */}
                                        <thead className="bg-gray-200 text-white w-full">
                                            <tr className="flex w-full">
                                                <th scope="col" className="px-6 py-1 w-1/6 text-start font-medium border">Client Code</th>
                                                <th scope="col" className="px-6 py-1 w-1/2 text-start font-medium border">Script Name</th>
                                                <th scope="col" className="px-6 py-1 w-1/5 text-start font-medium border">Order Type</th>
                                                <th scope="col" className="px-6 py-1 w-1/4 text-start font-medium border">Quantity</th>
                                                <th scope="col" className="px-6 py-1 w-1/3 text-start font-medium border">Order Status</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200 w-full">
                                            {lists &&
                                                lists.map((list, index) => (
                                                    <tr key={list.basketName} className={`flex items-center w-full hover:bg-gray-50
                                                                ${ index % 2 === 0 ? '' : 'bg-gray-100' }
                                                            `}>
                                                        <td className="px-6  w-1/6  text-gray-800  border">{list.clientCode}</td>
                                                        <td className="px-6 text-wrap  w-1/2 whitespace-nowrap text-gray-800 border">{list.scripName}</td>
                                                        <td className="px-6  w-1/5   text-gray-800 border ">{list.orderType}</td>
                                                        <td className="px-6  w-1/4   text-gray-800 border">{list.quantity}</td>
                                                        <td className="px-6  w-1/3 whitespace-nowrap  text-gray-800 border">{list.status}</td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div>}

                                {isMobileView && (
                                    <div className="space-y-3 px-2">
                                        {lists && lists.map((list, index) => (
                                            <div key={`${list.clientCode || 'client'}-${index}`} className="rounded-lg border border-gray-200 bg-white p-3 shadow-sm">
                                                <div className="grid grid-cols-1 gap-1.5 text-sm">
                                                    <div><span className="block text-[11px] font-semibold tracking-wide uppercase text-gray-700">Client Code</span><p className="text-gray-800">{list.clientCode || '-'}</p></div>
                                                    <div><span className="block text-[11px] font-semibold tracking-wide uppercase text-gray-700">Script Name</span><p className="text-gray-800 break-words">{list.scripName || '-'}</p></div>
                                                    <div><span className="block text-[11px] font-semibold tracking-wide uppercase text-gray-700">Order Type</span><p className="text-gray-800">{list.orderType || '-'}</p></div>
                                                    <div><span className="block text-[11px] font-semibold tracking-wide uppercase text-gray-700">Quantity</span><p className="text-gray-800">{list.quantity || '-'}</p></div>
                                                    <div><span className="block text-[11px] font-semibold tracking-wide uppercase text-gray-700">Order Status</span><p className="text-gray-800">{list.status || '-'}</p></div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TradeDetails

